export default __webpack_public_path__ + "static/media/1.8bfb9e0e.png";